import { Injectable } from '@angular/core';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class EntitiesInformationService {

  breadcrumInfo$ : BehaviorSubject<Object>

  constructor() { 
    this.breadcrumInfo$ = new BehaviorSubject<Object>(null)
  }
  
  clean (){
    // Clean dynamic data of breadcrumInfo
    this.breadcrumInfo$ = new BehaviorSubject<Object>(null)
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sidebar-information/entity-information.service.ts